
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCloudy as ObiCloudyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cloudy.js';
 
 
 

 
 export const ObiCloudy = createComponent({
   react: React,
   tagName: 'obi-cloudy',
   elementClass: ObiCloudyElement,
   events: {
     
   }
  });
 
 